/**
 * Resource Hub — highlights the chip for the section currently in view (sections/resource-grid.liquid).
 * Optional enhancement: chips are plain anchor links and work without this script.
 * No-ops when IntersectionObserver is unavailable.
 */
(function (win, doc) {
  'use strict';

  var ACTIVE_CLASS = 'is-active';

  function init() {
    var nav = doc.querySelector('[data-resource-hub-nav]');
    if (!nav || nav.getAttribute('data-resource-hub-init') === 'true') return;
    nav.setAttribute('data-resource-hub-init', 'true');

    var track = nav.querySelector('[data-resource-hub-track]');
    var chips = nav.querySelectorAll('[data-resource-hub-chip]');
    var chipById = {};
    var targets = [];

    for (var i = 0; i < chips.length; i++) {
      var id = (chips[i].getAttribute('href') || '').replace(/^#/, '');
      var target = id ? doc.getElementById(id) : null;
      if (!target) {
        chips[i].hidden = true;
        continue;
      }
      chipById[id] = chips[i];
      targets.push(target);
    }

    if (!targets.length || !('IntersectionObserver' in win)) return;

    var visible = {};
    var activeId = null;

    function setActive(id) {
      if (id === activeId) return;
      activeId = id;

      for (var key in chipById) {
        if (!Object.prototype.hasOwnProperty.call(chipById, key)) continue;
        var isActive = key === id;
        chipById[key].classList.toggle(ACTIVE_CLASS, isActive);
        if (isActive) {
          chipById[key].setAttribute('aria-current', 'true');
        } else {
          chipById[key].removeAttribute('aria-current');
        }
      }

      var chip = chipById[id];
      if (track && chip && track.scrollWidth > track.clientWidth) {
        track.scrollLeft = chip.offsetLeft - (track.clientWidth - chip.offsetWidth) / 2;
      }
    }

    var observer = new IntersectionObserver(function (entries) {
      for (var j = 0; j < entries.length; j++) {
        var entry = entries[j];
        visible[entry.target.id] = entry.isIntersecting || entry.intersectionRatio > 0;
      }
      for (var k = 0; k < targets.length; k++) {
        if (visible[targets[k].id]) {
          setActive(targets[k].id);
          return;
        }
      }
    }, { rootMargin: '-35% 0px -55% 0px' });

    for (var t = 0; t < targets.length; t++) {
      observer.observe(targets[t]);
    }
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window, document);
